import axios, { endpoints } from 'src/lib/axios';
import { getAuthHeaders } from 'src/auth/context';
import type { UsageEventType } from 'src/types/stats';

export const trackEvent = (
  eventType: UsageEventType,
  metadata?: Record<string, any>,
  duration?: number
): void => {
  axios
    .post(endpoints.stats.usageEvent, { eventType, metadata, duration }, getAuthHeaders())
    .catch((error) => console.error('Errore tracking evento', eventType, error));
};
